(function () {
  const initSwipers = () => {
    if (typeof Swiper === 'undefined') {
      setTimeout(initSwipers, 300);
      return;
    }

    document.querySelectorAll('.pickup-swiper').forEach((swiperEl) => {
      const prevBtn = swiperEl.querySelector('.swiper-button-prev');
      const nextBtn = swiperEl.querySelector('.swiper-button-next');

      const swiper = new Swiper(swiperEl, {
        slidesPerView: 'auto',
        centeredSlides: false, // ✅ 左揃えに変更
        loop: false,
        spaceBetween: 20,
        autoplay: false,
        navigation: {
          nextEl: nextBtn,
          prevEl: prevBtn
        },
        on: {
          init: function () {
            updateCaptions(this);
            updateArrowState(this);
          },
          slideChangeTransitionEnd: function () {
            updateCaptions(this);
            updateArrowState(this);
          }
        }
      });

      function updateCaptions(swiperInstance) {
        swiperInstance.slides.forEach(slide => {
          slide.classList.remove('active-caption');
        });
        const realIndex = swiperInstance.realIndex;
        const slides = swiperInstance.slides;
        if (slides[realIndex]) {
          slides[realIndex].classList.add('active-caption');
        }
      }

      function updateArrowState(swiperInstance) {
        if (prevBtn && nextBtn) {
          prevBtn.style.opacity = swiperInstance.isBeginning ? '0.3' : '1';
          prevBtn.style.pointerEvents = swiperInstance.isBeginning ? 'none' : 'auto';

          nextBtn.style.opacity = swiperInstance.isEnd ? '0.3' : '1';
          nextBtn.style.pointerEvents = swiperInstance.isEnd ? 'none' : 'auto';
        }
      }
    });
  };

  initSwipers();
})();
